// ==============================================
// ==================Import======================
// ==============================================

// ==================Library===================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function NodeInfoTab({ nodeInfoTab, nodeInfoMap }) {
  // function to create tabe to insert in JSX
  function createTabe(el) {
    const tabe = [];
    for (let i = 0; i < el.value.table[0].Document.length; i += 1) {
      if (el.value.table[0].Document[i].Document.file !== '') {
        tabe.push(
          <div className="tab" key={el.id + el.value.table[0].Document[i].Document.file}>
            <p>{el.value.table[0].table.data[i][0]}</p>
            <p>{el.value.table[0].table.data[i][1]}</p>
            <p>
              <a
                href={el.value.table[0].Document[i].Document.file}
                target="_blank"
                rel="noreferrer"
              >
                {el.value.table[0].table.data[i][2]}
              </a>
            </p>
          </div>,
        );
      }
    }
    return tabe;
  }
  return (
    <>
      <div className="nodeInfoTab--container">
        <h2 id="BecomeNode">{nodeInfoTab.title}</h2>
        {nodeInfoTab.block_table.map((el) => (
          <div key={el.id}>
            <p className="subtitleHelp">{el.value.table[0].table.table_caption}</p>
            {createTabe(el)}
          </div>
        ))}
      </div>
      <div className="nodeInfoMap--contact">
        <h3 className="nodeInfoMap--contact--title">{nodeInfoMap.contact[0].value.title}</h3>
        <p className="nodeInfoMap--contact--para">
          <a
            href={`mailto:${nodeInfoMap.contact[0].value.item[0].email}`}
          >
            {nodeInfoMap.contact[0].value.item[0].value}
          </a>
        </p>
      </div>
    </>
  );
}

NodeInfoTab.propTypes = {
  nodeInfoTab: PropTypes.shape({
    title: PropTypes.string,
    block_table: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      }),
    ).isRequired,
  }).isRequired,
  nodeInfoMap: PropTypes.shape({
    table_documentation: PropTypes.shape({
      title: PropTypes.string,
    }),
    contact: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.shape({
          title: PropTypes.string,
          item: PropTypes.arrayOf(
            PropTypes.shape({
              value: PropTypes.string,
              email: PropTypes.string,
            }),
          ),
          id: PropTypes.string,
        }),
      }),
    ),
  }).isRequired,
};

export default NodeInfoTab;
